<template>
	<div ref="LocationSelector" class="LocationSelector">
	</div>
</template>

<script>
import MapLocationSelector from './LocationSelectorRaw/MapLocationSelector.js'
import { mount } from 'redom'
import { mapActions } from 'vuex'

const pinUrl = require('../assets/map-location-selector-pin.png')

export default {
	name: 'LocationSelector',
	props: [],
	data: () => ({}),
	computed: {
		globalState() {
			return this.$store.state
		},
	},
	methods: {
		...mapActions(['setPartnerDataValue']),
	},
	components: {},
	mounted() {
		let container = this.$refs.LocationSelector
		mount(
			container,
			new MapLocationSelector({
				centerPinImageUrl: pinUrl,
				zoom: 17,
				latitude: this.globalState.latitude || 61,
				longitude: this.globalState.longitude || 25,
				centerChanged: (latitude, longitude) => {
					this.setPartnerDataValue({ key: 'latitude', value: latitude })
					this.setPartnerDataValue({ key: 'longitude', value: longitude })
				},
			})
		)
	},
}
</script>

<style src="./LocationSelectorRaw/MapLocationSelector.css">
</style>
<style lang="stylus" scoped>
.LocationSelector {
}
</style>
